import axios from '@/libs/api.request'
var qs = require('qs');
// 获取列表数据
export const fetchTableList = (params) => {
    let data = qs.stringify(params)

    return axios.request({
        url: '/order/school-list',
        data,
        method: 'post'
    })
};
// 支付
export const setPay = (params) => {
    let data = params
    data = qs.stringify(data)
    return axios.request({
        url: '/order/school-pay-list',
        data,
        method: 'post'
    })
};
// 删除
export const setDel = (params) => {
    let data = params
    data = qs.stringify(data)
    return axios.request({
        url: '/order/delete',
        data,
        method: 'post'
    })
};